import { useState } from "react";
import { Link } from "react-router-dom";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [activePage, setActivePage] = useState("home");
  return (
    <>
      <div className="block md:hidden py-1 px-28 shadow   ">
        {/* desktop */}
        <div className="  flex justify-between ">
          <div>
            <img src="/logo.png" className="w-44  h-auto " />
          </div>
          <div className="flex items-center text-lg  text-gray-500">
            <ul className="flex justify-between ">
              <Link to="/">
                {" "}
                <li
                  className={`   w-full ${
                    activePage === "home"
                      ? " border-b-4 border-[#f9ffa0] px-3 py-1 rounded-lg"
                      : " "
                  }`}
                  onClick={() => setActivePage("home")}
                >
                  Home
                </li>
              </Link>
              <Link to="/Investment">
                {" "}
                <li
                  className={`ml-3  w-full ${
                    activePage === "gethired"
                      ? "border-b-4 border-[#f9ffa0] px-3 py-1 rounded-lg"
                      : " "
                  }`}
                  onClick={() => setActivePage("gethired")}
                >
                  Invesment
                </li>
              </Link>
              <Link to="/sales">
                {" "}
                <li
                  className={`ml-4    w-full ${
                    activePage === "volunter"
                      ? " border-b-4 border-[#f9ffa0] px-3 py-1 rounded-lg "
                      : " "
                  }`}
                  onClick={() => setActivePage("volunter")}
                >
                  Sales
                </li>
              </Link>

              <Link to="/About">
                {" "}
                <li
                  className={` ml-4 w-full ${
                    activePage === "about"
                      ? "  border-b-4 border-[#f9ffa0] px-3 py-1 rounded-lg "
                      : " "
                  }`}
                  onClick={() => setActivePage("about")}
                >
                  About
                </li>
              </Link>

              <Link to="/Article">
                {" "}
                <li
                  className={`ml-4 mr-8 w-20 ${
                    activePage === "article"
                      ? " border-b-4 border-[#f9ffa0] px-3 py-1 rounded-lg  "
                      : " "
                  }`}
                  onClick={() => setActivePage("article")}
                >
                  Article
                </li>
              </Link>
            </ul>

            <Link to="/contact">
              <button className="bg-[#74d600] text-white  font-semibold px-4 py-2 rounded-lg  ">
                Contact
              </button>
            </Link>
          </div>
        </div>
      </div>
      {/* mobile and tablet */}

      {/* <div className="md:block hidden  w-full py-3  px-5">
        <div className=" flex items-center justify-between">
          <div className="mr-20">
            <img src="/logo4.png" className="w-44  h-auto  " />
          </div>
          <div
            className="  w-full  flex justify-end  z-30 h-10    "
            onClick={() => setIsOpen((prev) => !prev)}
          >
            {isOpen ? (
              <div>
                <img src="/close.png" className="w-8 h-8  mb-5 " />
              </div>
            ) : (
              <div>
                <img src="/menu.png" className="w-6 h-6 " />
              </div>
            )}
          </div>
        </div>
        {isOpen && (
          <div className="sm:w-52 md:w-96 absolute  bg-gray-100    top-0  right-0 h-screen   ">
            <div
              className="flex justify-end  border-b-2 
               border-gray-200 items-center mt-16 "
            />
            <div className="flex items-center pt-28 flex-col text-xl font-poppins text-gray-500 py-10">
              <ul className="flex flex-col justify-around ">
                <Link to="/">
                  {" "}
                  <li
                    className={`mb-3  w-14 ${
                      activePage === "home"
                        ? " bg-green-400 px-3 py-1 rounded-lg text-white"
                        : " "
                    }`}
                    onClick={() => setActivePage("home")}
                  >
                    Home
                  </li>
                </Link>
                <Link to="/About">
                  {" "}
                  <li
                    className={`mb-3  w-14 ${
                      activePage === "about"
                        ? " bg-green-400 px-3 py-1 rounded-lg text-white"
                        : " "
                    }`}
                    onClick={() => setActivePage("about")}
                  >
                    About
                  </li>
                </Link>

                <Link to="/Volunteer">
                  {" "}
                  <li
                    className={`  mb-3  w-20 ${
                      activePage === "volunter"
                        ? " bg-green-400 px-3 py-1 rounded-lg text-white"
                        : " "
                    }`}
                    onClick={() => setActivePage("volunter")}
                  >
                    Volunteer
                  </li>
                </Link>
                <Link to="/gethired">
                  {" "}
                  <li
                    className={`mb-3  w-20 ${
                      activePage === "gethired"
                        ? " bg-green-400 px-3 py-1 rounded-lg text-white"
                        : " "
                    }`}
                    onClick={() => setActivePage("gethired")}
                  >
                    GetHired
                  </li>
                </Link>
                <Link to="/Article">
                  {" "}
                  <li
                    className={`mb-7 w-16 ${
                      activePage === "article"
                        ? " bg-green-400 px-3 py-1 rounded-lg text-white "
                        : " "
                    }`}
                    onClick={() => setActivePage("article")}
                  >
                    Article
                  </li>
                </Link>
              </ul>
              <button className="bg-yellow-300 text-white font-semibold px-6 py-3 rounded-md  ">
                Donate
              </button>
            </div>
          </div>
        )}
      </div> */}
    </>
  );
}

export default Navbar;
